import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const campaignMappingsApi = createApi({
    reducerPath: 'campaignMappingsApi',
    baseQuery: baseQuery,
    tagTypes: ['CampaignMappings'],
    endpoints: (builder) => ({
        createCampaignMapping: builder.mutation({
            query: ({ body }) => ({
                url: '/campaign_mappings/create_campaign_mapping',
                method: 'PUT',
                body: body
            }),
            invalidatesTags: ['CampaignMappings'],
        }),
        listCampaignMappings: builder.query({
            query: ({ clientName, clientRegion }) => ({
                url: '/campaign_mappings/list_campaign_mappings',
                method: 'GET',
                params: {
                    client_name: clientName,
                    client_region: clientRegion
                }
            }),
            providesTags: ['CampaignMappings'],
        }),
        deleteCampaignMapping: builder.mutation({
            query: ({ body }) => ({
                url: '/campaign_mappings/delete_campaign_mapping',
                method: 'DELETE',
                body: body
            }),
            invalidatesTags: ['CampaignMappings'],
        }),
        updateCampaignMappingConfig: builder.mutation({
            query: ({ body }) => ({
                url: '/campaign_mappings/update_campaign_mapping_config',
                method: 'PUT',
                body: body
            }),
            invalidatesTags: ['CampaignMappings'],
        }),
        getCampaignMappingConfig: builder.query({
            query: ({ clientName, clientRegion, configName }) => ({
                url: '/campaign_mappings/get_campaign_mapping_config',
                method: 'GET',
                params: {
                    client_name: clientName,
                    client_region: clientRegion,
                    config_name: configName
                }
            }),
            providesTags: ['CampaignMappings'],
        }),
        getRegexMapTable: builder.query({
            query: ({ clientName, clientRegion, configName, startDate, endDate }) => ({
                url: '/campaign_mappings/get_regex_map_table',
                method: 'POST',
                body: {
                    client_name: clientName,
                    client_region: clientRegion,
                    config_name: configName,
                    start_date: startDate,
                    end_date: endDate
                }
            }),
            providesTags: ['CampaignMappings'],
        }),
        getCampaignMappingDropdownsWithOptions: builder.query({
            query: ({ clientName }) => ({
                url: '/campaign_mappings/get_campaign_mapping_dropdowns_with_options',
                method: 'GET',
                params: {
                    client_name: clientName,
                    client_region: 'ALL'
                }
            }),
            providesTags: ['CampaignMappings'],
        }),
    }),
});

export const {
    useCreateCampaignMappingMutation,
    useListCampaignMappingsQuery,
    useDeleteCampaignMappingMutation,
    useUpdateCampaignMappingConfigMutation,
    useGetCampaignMappingConfigQuery,
    useGetRegexMapTableQuery,
    useGetCampaignMappingDropdownsWithOptionsQuery
} = campaignMappingsApi;

export default campaignMappingsApi.reducer;